import { createGenericFetchMachine } from '@/common/overmind/machines/generic-fetch-machine';
import type { SubtypeRecord } from '@/overmind/effects/adapters/baseadapter';

import * as actions from './actions';

const state = createGenericFetchMachine<SubtypeRecord>();

export { state, actions };
